import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);
export const useTheme = () => useContext(ThemeContext);

function applyTheme(theme) {
  const el = document.documentElement;
  if (theme === "light") el.classList.add("light");
  else el.classList.remove("light");
  const color = theme === "light" ? "#E9EBF2" : "#0B0B12";
  let m = document.querySelector('meta[name="theme-color"]');
  if (!m) {
    m = document.createElement("meta");
    m.setAttribute("name", "theme-color");
    document.head.appendChild(m);
  }
  m.setAttribute("content", color);
  document.body.style.background = color;
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("fv_theme") || "dark");

  useEffect(() => {
    applyTheme(theme);
    localStorage.setItem("fv_theme", theme);
  }, [theme]);

  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
}
